// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uwCiu{gap:24px}.qNL9s{gap:8px}.bCqCU{gap:16px}.g1eW_{gap:8px}.Nj1dQ{gap:16px;align-items:center}.fpzri{gap:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `uwCiu`,
	"bundleRate": `qNL9s`,
	"bundleRateRow": `bCqCU`,
	"includedServices": `g1eW_`,
	"includedService": `Nj1dQ`,
	"actions": `fpzri`
};
export default ___CSS_LOADER_EXPORT___;
